import Immutable from 'immutable';

import type Url from 'sharedreact/data/Url';

const Content: {
  id?: string,
  fileUrl: Url | null,
  fileType: string | null,
  usage: string | null,
  pageNr: number,
  occurence: number,
  available: boolean
} = {
  id: undefined, // TODO FileInfoExternalReference should have an id that is set by the server
  fileUrl: null,
  fileType: null,
  usage: null,
  pageNr: -1,
  occurence: -1,
  available: false
};

class FileInfoExternalReference extends Immutable.Record(Content) {
}

export default FileInfoExternalReference;
